var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-btn',_vm._b({attrs:{"color":"primary"},on:{"click":_vm.promptInstallation}},'v-btn',_vm.$attrs,false),[_vm._v(" add to homescreen "),_c('v-icon',{attrs:{"right":""}},[_vm._v(_vm._s(_vm.platformIcon))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }